export const MOBILE_PLATFORM = 'mobile';

export const ENTRY_CONTENT = {
  MAIN: 'main',
};

export const ENTRY_RENDER_TYPE = {
  ANCHOR_SECTION: 'anchor-section',
  AD: 'ad',
  HTML: 'html',
  PHOTO: 'photo',
  VIDEOS: 'videos',
  TABLE: 'table',
  ARTICLE_OFFERS_AD: 'article-offers-ad',
  CAR_NEWS_MODULE: 'car-news-module',
  NEWS_MODULE: 'news-module',
  EV_NEWS_MODULE: 'ev-news-module',
  TYPE_NEWS_MODULE: 'type-news-module',
  VEHICLE_TESTING_TEAM: 'vehicle-testing-team',
  COMPARE: 'compare',
  INFO_GRAPHIC: 'info-graphic',
  HVS_MODULE: 'hvs-module',
};

export const ENTRY_ID = {
  COMPARE: 'compare',
};
